import DpitBuilder from './modules/DpitBuilder';
import { loadBuilder } from '../../../includes/assets/js/modules/dpitUtilsInc';
import AdminThemeColors from '../../../includes/assets/js/modules/AdminThemeColors';

jQuery(window).on('load', () => {
	window.$ = jQuery;
	loadBuilder(window.dpIntroTourPublicConfig, (mainCfg, tourCfg) => {
		new DpitBuilder(mainCfg, tourCfg);
		new AdminThemeColors(mainCfg);
	});
});
